// TEMPORARY data-quality flag — chakra_dashboard#135.
//
// Accounts whose trade history is incomplete (missing days vs bhavcopy's
// active trading days), so their derived figures may be inaccurate.
// Their data is STILL SHOWN as-is; we just surface a low-key,
// persistent "incomplete data" flag — a banner on the account page and a
// marker on that account's column in the portfolio reports. Not excluded
// from totals; the specifics of what's missing are handled offline.
//
// REVERSAL: once an account's data is supplied and verified, remove its
// alias from the set below. When the set is empty, delete this file and
// its call sites (grep `isIncompleteAccount`). Tracked in #135.

export const INCOMPLETE_DATA_ACCOUNTS: ReadonlySet<string> = new Set([
  "MARLIM4.MD.X",
]);

/** True when this account's data is known-incomplete and should carry an
 *  "incomplete data" flag (the data itself is still shown). */
export function isIncompleteAccount(account: string | null | undefined): boolean {
  return account != null && INCOMPLETE_DATA_ACCOUNTS.has(account);
}
